import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import FamilyInvitesTable from '../family-invites/table.gts';
import { Section } from 'tio-ui/components/layout';

export interface ProfileFamilyInvitesSignature {
  Args: {
    employees: EmployeeModel[];
    limit?: number;
  };
  Element: HTMLElement;
}

const FamilyInvitesComponent: TOC<ProfileFamilyInvitesSignature> = <template>
  <Section @collapsed={{true}}>
    <:header>Family Invites</:header>
    <:body>
      {{#if @employees.length}}
        <FamilyInvitesTable @limit={{if @limit @limit 10}} @employees={{@employees}} />
      {{else}}
        <div
          class="px-2 py-2 tio-bg-surface border-t tio-border-default h-9 tio-fg-muted text-center"
        >
          {{t "pslf.no_employee_record"}}
        </div>
      {{/if}}
    </:body>
  </Section>
</template>;

export default FamilyInvitesComponent;
